import { StyleSheet } from 'react-native';

import { COLOR, whiteTransparent } from 'utils/colors';
import { heightPercentageToDP } from 'utils/responsiveness';

export const progressBarMargin = 8;

const styles = StyleSheet.create({
    root: {
        margin: progressBarMargin,
        position: 'absolute',
        bottom: 0,
        right: 0,
        left: 0,
    },
    container: {
        height: heightPercentageToDP(4),
        backgroundColor: whiteTransparent(0.2),
        borderRadius: 4,
        overflow: 'hidden',
    },
    progress: {
        height: heightPercentageToDP(4),
    },
});

export default styles;
